export default {
	bidButton: {
		desktop: 'Submit bid',
		mobile: 'Place bid',
	},
	validationErrors: {
		genericBid: 'Please enter a valid bid.',
		minimumBidAmountProxy: 'You must bid at least £{minimum}.',
	},
};
